import battery20 from "../../assets/images/fuel-icon.svg";
import heart from "../../assets/images/health-icon.svg";
import smiley from "../../assets/images/energy-icon.svg";
import Layout from "../../components/Layout/Layout";
import "./Dashboard.scss";

const Dashboard = () => {
  return (
    <Layout requiresAuth={true}>
      <div className="dashboard">
        <div>
          <h1 className="dashboard__title">Oom&apos;s Needs</h1>
        </div>

        <div className="dashboard__contents">
          <div className="dashboard__contents-energy-level">
            <div className="dashboard__contents-heading dashboard__contents-heading--green">
              <h2 className="dashboard__contents-heading-title">
                Energy Level
              </h2>
              <img src={smiley} alt="Energy Level" />
            </div>
            <p className="dashboard__contents-heading-subtext">
              This is Oom&apos;s current energy level. Take regular breaks from
              playing to allow Oom to recover.
            </p>
            <div className="dashboard__dotted-line" />
          </div>

          <div className="dashboard__contents-fuel-level">
            <div className="dashboard__contents-heading dashboard__contents-heading--yellow">
              <h2 className="dashboard__contents-heading-title">Fuel Level</h2>
              <img src={battery20} alt="Fuel Level" />
            </div>

            <p className="dashboard__contents-heading-subtext">
              Oom&apos;s spaceship lost all its fuel on its collision with
              earth. Refill this to 100% to get Oom safely back home!
            </p>
            <div className="dashboard__dotted-line" />
          </div>

          <div className="dashboard__contents-health-level">
            <div className="dashboard__contents-heading dashboard__contents-heading--red">
              <h2 className="dashboard__contents-heading-title">
                Health Level
              </h2>
              <img src={heart} alt="Health Level" />
            </div>

            <p className="dashboard__contents-heading-subtext">
              Oom needs to be at his strongest and healthiest to learn the
              alphabet.
            </p>
            <div className="dashboard__dotted-line" />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
